import React, { useState, useEffect } from "react";
import { MdOutlineClose } from "react-icons/md";
import { useAtom } from "jotai";
import {
  fieldsDetail,
  isFormAtom,
} from "../../components/admin/DndTemplate/DndAtom/DndTemplateAtom";
import CuInput from "../../all-patient/components/CuInput";
import {
  useCreateItem,
  useSecureDeleteItem,
  useUpdateItem,
} from "../../_helper/actions/mutation/items";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import CuButton from "../../all-patient/components/CuButton";
import { toast } from "react-toastify";

const FormComponent = ({ selectedValue }) => {
  //   console.log(selectedValue);
  const [isForm, setIsForm] = useAtom(isFormAtom);
  const [fields, setFields] = useAtom(fieldsDetail);
  const [clinic] = useAtom(clinicAtom);
  const [formValue, setFormValue] = useState({
    display_name: "",
    name: "",
    type: "",
    size_from: "",
    size_to: "",
    hint: "",
  });
  const [isChecked, setIsChecked] = useState({
    everyone: false,
    active: false,
    editable: false,
    is_required: false,
  });

  const filterFields = fields.filter((ele) => ele.id == isForm?.id);
  //("filter fields-------", filterFields[0]);

  useEffect(() => {
    if (isForm?.isEdit) {
      const selectedField = filterFields[0];
      setFormValue({
        id: isForm.id,
        display_name: selectedField?.display_name,
        name: selectedField?.name,
        type: selectedField?.type,
        size_from: selectedField?.size?.to,
        size_to: selectedField?.size?.from,
        hint: selectedField?.size?.hint,
      });
      setIsChecked({
        everyone: selectedField?.everyone,
        active: selectedField?.active,
        editable: selectedField?.editable,
        is_required: selectedField?.is_required,
      });
    }
  }, [fields, isForm.id]);

  //("form value---------", formValue);

  const onClose = () => {
    if (!isForm.isEdit) {
      const temp = fields.filter((ele) => ele.id !== formValue.id);
      setFields(temp);
      setIsForm({ isForm: false, id: "" });
    } else {
      setIsForm({ isForm: false, id: "" });
    }
  };

  const submitHander = (e) => {
    e.preventDefault();

    setFields((prevFields) => {
      // Check if the formValue's id already exists in the fields array
      const existingFieldIndex = prevFields.findIndex(
        (field) => field.id === isForm.id
      );

      if (existingFieldIndex !== -1) {
        // Update the existing field by creating a new array with the updated field
        return prevFields.map((field, index) =>
          index === existingFieldIndex ? { ...formValue, id: isForm.id } : field
        );
      } else {
        // If the id doesn't exist, add a new field
        return [...prevFields, { ...formValue, id: isForm.id || Date.now() }];
      }
    });

    // Reset form modal state
    setIsForm({ isForm: false, id: "" });
  };

  //   const customMutation = useCreateItem(ApiEndPoint.CUSTOM_FIELDS);

  //   const submitHandler = (e) => {
  //     e.preventDefault();
  //     const payload = {
  //       backend: true,
  //       action: "postCustomFields",
  //       name: formValue.name,
  //       display_name: formValue.display_name,
  //       type: formValue.type,
  //       module_name: selectedValue,
  //       is_required: isChecked.is_required,
  //       clinic_id: clinic?.id,
  //       offset: "slots",
  //       size: {
  //         to: formValue.size_to,
  //         from: formValue.size_from,
  //         hint: formValue.hint,
  //       },
  //       active: isChecked.active,
  //       editable: isChecked.editable,
  //     };

  //     customMutation.mutate(payload, {
  //       onSuccess: (data) => {
  //         const temp = [...fields];
  //         temp[isForm.id - 1] = { ...formValue, ...isChecked, created: true };
  //         setFields(temp);
  //         setIsForm({ isForm: false, id: "" });
  //       },
  //       onError: (error) => {
  //         //("error-------", error);
  //       },
  //     });
  //   };

  //   const deleteHandler = () => {
  //     if (!isForm.isEdit) {
  //       const temp = fields.filter((ele) => ele.id !== formValue.id);
  //       setFields(temp);
  //       setIsForm({ isForm: false, id: "" });
  //     } else {
  //       setIsForm({ isForm: false, id: "" });
  //     }
  //   };

  //   const updateMutation = useUpdateItem(ApiEndPoint.CUSTOM_FIELDS);

  //   const updateHandler = () => {
  //     const payload = {
  //       id: isForm?.id,
  //       backend: true,
  //       action: "patchCustomFields",
  //       name: formValue.name,
  //       display_name: formValue.display_name,
  //       type: formValue.type,
  //       module_name: selectedValue,
  //       is_required: isChecked.is_required,
  //       clinic_id: clinic?.id,
  //       size: {
  //         to: formValue.size_to,
  //         from: formValue.size_from,
  //         hint: formValue.hint,
  //       },
  //       active: isChecked.active,
  //       editable: isChecked.editable,
  //     };
  //     updateMutation.mutate(
  //       { id: isForm?.id, data: payload },
  //       {
  //         onSuccess: (data) => {
  //           //("update data--------", data);
  //           setIsForm({ isForm: false, id: "", isEdit: false });
  //         },
  //         onError: (error) => {
  //           //("update error-------", error);
  //         },
  //       }
  //     );
  //   };

  //("isform--------", isForm);

  return (
    <div className="w-full px-4 py-6 text-[15.56px] leading-[31.11px] relative">
      <div className="absolute right-1 top-1 cursor-pointer" onClick={onClose}>
        <MdOutlineClose size={25} />
      </div>
      <div className="w-full h-full mt-4">
        <div className="flex justify-between items-center">
          <div>Display Name</div>
          <div className="w-[330px] h-[54.22px]">
            <CuInput
              type="text"
              value={
                isForm?.isPredifined
                  ? isForm?.data?.name
                  : formValue.display_name
              }
              onChange={(e) =>
                setFormValue((prevState) => ({
                  ...prevState,
                  display_name: e.target.value,
                }))
              }
              disabled={isForm?.isPredifined}
            />
          </div>
        </div>

        <div className="flex justify-between items-center">
          <div className="w-[130px]">Field Type</div>
          <div className="w-[330px] h-[54.22px] flex items-center">
            {isForm?.isPredifined ? isForm?.data?.type : formValue?.type}
          </div>
        </div>
        {/* <div className="flex justify-between items-center">
          <div className="w-[130px]">Who can see this field?</div>
          <div className="w-[330px]">
            <Checkbox
              checked={isChecked.everyone}
              onChange={(e, data) =>
                setIsChecked((prevState) => ({
                  ...prevState,
                  everyone: !isChecked.everyone,
                }))
              }
              disabled={isForm?.isPredifined}
            />
          </div>
        </div> */}
        {isForm?.isPredifined ? (
          ""
        ) : (
          <div className="flex justify-between items-center">
            <div className="w-[130px]">Size</div>
            <div className="w-[330px] h-[54.22px] flex items-center gap-2">
              <CuInput
                type="text"
                value={formValue.size_from}
                onChange={(e) =>
                  setFormValue((prevState) => ({
                    ...prevState,
                    size_from: e.target.value,
                  }))
                }
                disabled={isForm?.isPredifined}
              />{" "}
              <span>to</span>
              <CuInput
                type="text"
                value={formValue.size_to}
                onChange={(e) =>
                  setFormValue((prevState) => ({
                    ...prevState,
                    size_to: e.target.value,
                  }))
                }
                disabled={isForm?.isPredifined}
              />{" "}
              <span>Characters</span>
            </div>
          </div>
        )}
        <div className="flex justify-between items-center">
          <div className="w-[130px]">Active</div>
          <div className="w-[330px]">
            <input
              type="checkbox"
              checked={isChecked.active}
              onChange={(e, data) =>
                setIsChecked((prevState) => ({
                  ...prevState,
                  active: !isChecked.active,
                }))
              }
            />
          </div>
        </div>
        {isForm?.isPredifined ? (
          ""
        ) : (
          <div className="flex justify-between items-center">
            <div className="w-[130px]">Editable</div>
            <div className="w-[330px]">
              <input
                type="checkbox"
                checked={isChecked.editable}
                onChange={(e, data) =>
                  setIsChecked((prevState) => ({
                    ...prevState,
                    editable: !isChecked.editable,
                  }))
                }
                disabled={isForm?.isPredifined}
              />
            </div>
          </div>
        )}
        {isForm?.isPredifined ? (
          ""
        ) : (
          <div className="flex justify-between items-center">
            <div className="w-[130px]">Required</div>
            <div className="w-[330px]">
              <input
                type="checkbox"
                checked={isChecked.is_required}
                onChange={(e, data) =>
                  setIsChecked((prevState) => ({
                    ...prevState,
                    is_required: !isChecked.is_required,
                  }))
                }
                disabled={isForm?.isPredifined}
              />
            </div>
          </div>
        )}
        {isForm?.isPredifined ? (
          ""
        ) : (
          <div className="flex justify-between items-center">
            <div className="w-[130px]">Hint</div>
            <div className="w-[330px] h-[54.22px]">
              <CuInput
                type="text"
                value={formValue.hint}
                onChange={(e) =>
                  setFormValue((prevState) => ({
                    ...prevState,
                    hint: e.target.value,
                  }))
                }
                disabled={isForm?.isPredifined}
              />
            </div>
          </div>
        )}

        <div className="w-full flex justify-end gap-2">
          <CuButton
            className="w-[144.45px] h-[48.89px] rounded-[5.56px] text-[17.78px] border"
            // onClick={deleteHandler}
          >
            Cancel
          </CuButton>
          <CuButton
            className="w-[144.45px] h-[48.89px] rounded-[5.56px] text-[17.78px] border"
            onClick={submitHander}
            // isLoading={
            //   isForm?.isEdit
            //     ? updateMutation.isLoading
            //     : customMutation.isLoading
            // }
            disabled={isForm?.isPredifined}
          >
            {isForm?.isEdit || isForm?.isPredifined ? "Update" : "Submit"}
          </CuButton>
        </div>
      </div>
    </div>
  );
};

export default FormComponent;
